// Type guard to check if the error has a message property
const isErrorWithMessage = (error: unknown): error is { message: string } => {
    return typeof error === 'object' && error !== null && 'message' in error;
}

export const errorUtils = {
    isErrorWithMessage
}